export default "__VITE_ASSET__BbOI2QEn__"